import { Flex, IllustratedMessage } from '@percent/lemonade'
import styles from './EmptyState.module.scss'

export interface EmptyStateProps {
  illustration: 'no-grant-programs' | 'no-tasks' | 'no-grant-candidates'
  title?: string
  description?: string
  cta?: {
    label: string
    onClick: VoidFunction
  }
}

export const EmptyState = ({ illustration, title, description, cta }: EmptyStateProps) => (
  <Flex className={styles.emptyStateContainer}>
    <IllustratedMessage illustration={illustration} title={title} description={description} cta={cta} />
  </Flex>
)
